import Country from '../../../api/Country';
import * as types from "../country/mutation-types";

export const getAll = async ({commit}) => {
    const json = await new Country().getAll();

    commit(types.COUNTRIES, json);
};

export default {
    getAll,
};



// WEBPACK FOOTER //
// ./src/store/modules/country/actions.js